/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  window.addEventListener("load", function () {
    var d = document,
      s = "script",
      id = "equallyWidget";
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://widget.equally.ai/equally-widget.min.js";
    fjs.parentNode.insertBefore(js, fjs);

    if (!window.EQUALLY_AI_API_KEY) {
      window.EQUALLY_AI_API_KEY = "l308y9qsm580kxsk0bghd5ijr02h05ru";
      var intervalId = setInterval(function () {
        if (window.EquallyAi) {
          clearInterval(intervalId);
          window.EquallyAi = new EquallyAi();
        }
      }, 500);
    }
  });

  

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
